import React from 'react'
// icons
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'

import { format } from 'date-fns'

import styled from 'styled-components'

// theme
import aampeTheme from '../../../constants/aampeTheme'

const CalendarHeader = ({
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
}) => (
    <Wrapper>
        <HeaderButton
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
        >
            <FiChevronLeft />
        </HeaderButton>
        <HeaderText>{format(date, 'MMM yyyy')}</HeaderText>
        <HeaderButton
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
        >
            <FiChevronRight />
        </HeaderButton>
    </Wrapper>
)

const Wrapper = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: aampeTheme.colors.white,
    width: '100%',
    padding: aampeTheme.spacing(1, 0, 0),
})

const HeaderButton = styled.button({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: aampeTheme.colors.white,
    border: 'none',
    color: aampeTheme.colors.neutral09,
    fontSize: '20px',
    cursor: 'pointer',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    '&:hover': {
        color: aampeTheme.colors.bordersWG01,
    },
    ':active': {
        backgroundColor: aampeTheme.colors.backgroundWG01,
        color: aampeTheme.colors.white,
    },
})

const HeaderText = styled.span({
    color: aampeTheme.colors.gray800,
    fontSize: '16px',
    fontWeigth: 500,
})

export default CalendarHeader
